import { render } from "./PurchaseReport.vue?vue&type=template&id=37554890&scoped=true"
import script from "./PurchaseReport.vue?vue&type=script&lang=js"
export * from "./PurchaseReport.vue?vue&type=script&lang=js"

import "./PurchaseReport.vue?vue&type=style&index=0&id=37554890&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37554890"]])

export default __exports__